<template>
  <div id="TrajectoryBox">
    <el-form class="trajectoryForm" label-width="70px" :model="formTrajectory" size="mini">
      <el-form-item label="选择车辆">
        <el-autocomplete class="inline-input" v-model="formTrajectory.deviceNo" :fetch-suggestions="querySearch" placeholder="请选择车辆" size="mini" @select="handleSelect"></el-autocomplete>
      </el-form-item>
      <el-form-item label="开始时间">
        <el-date-picker class="timePicker" v-model="formTrajectory.startTime" type="datetime" placeholder="选择日期时间" default-time="00:00:00" size="mini" @change="handleStartTimeChange"></el-date-picker>
      </el-form-item>
      <el-form-item label="结束时间">
        <el-date-picker class="timePicker" v-model="formTrajectory.endTime" type="datetime" placeholder="选择日期时间" default-time="23:59:59" size="mini" @change="handleEndTimeChange"></el-date-picker>
      </el-form-item>
    </el-form>
    <div class="btnBlock">
      <el-button class="btnItem" type="primary" size="mini" @click="checkPlyLocus(formTrajectory)">查询轨迹</el-button>
      <el-button class="btnItem" type="primary" size="mini" @click="backBiBaseLayer">返回</el-button>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { getMap } from '@/utils/mainMap2';
import carMarkerIcon from '@/assets/icon/car_icon.gif';
import carStartIcon from '@/assets/icon/startPoint.gif';
import carEndIcon from '@/assets/icon/endPoint.gif';
import { api } from '@/api';
import { Loading } from 'element-ui';

let globalLoading;

export default {
  name: 'Trajectory',
  props: {
    selectedDeviceNo: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      labelPosition: 'right',
      formTrajectory: {
        deviceNo: '',
        endTime: '',
        startTime: ''
      },
      suggestions: null,
      polyline: null, // trajectory polyline instance
      marker: null, // marker instance
      cruiseInterval: null, // timer id for route playback
      startMarker: null,
      endMarker: null
    };
  },
  computed: {
    ...mapState('bi', ['querySearchData'])
  },
  watch: {
    selectedDeviceNo: {
      immediate: true,
      handler(value) {
        if (value) {
          this.formTrajectory.deviceNo = value;
        }
      }
    },
    querySearchData: {
      immediate: true,
      handler(value) {
        this.suggestions = value || [];
      }
    }
  },
  mounted() {
    this.suggestions = this.querySearchData;
    this.map = getMap();
  },
  methods: {
    ...mapActions('bi', ['getPlyLocus']),
    querySearch(queryString, cb) {
      const queryDataList = this.suggestions;
      const results = queryString ? this.createFilter(queryDataList, queryString) : queryDataList;
      // return suggestion list via callback
      cb(results);
    },
    createFilter(queryDataList, queryString) {
      return queryDataList.filter((item) => item.value.toLowerCase().includes(queryString.toLowerCase()));
    },
    // convert selected Date to timestamp(ms)
    convertToTimestamp(selecteDate) {
      if (selecteDate) {
        // 13-digit unix timestamp in milliseconds
        const timestamp = selecteDate.getTime();
        return timestamp;
      } else {
        console.log('璇峰厛閫夋嫨鏃ユ湡鏃堕棿');
        return null;
      }
    },
    handleStartTimeChange() {
      this.formTrajectory.startTime = this.convertToTimestamp(this.formTrajectory.startTime);
    },
    handleEndTimeChange() {
      this.formTrajectory.endTime = this.convertToTimestamp(this.formTrajectory.endTime);
    },
    async checkPlyLocus({ deviceNo = null, carNo = null, returnCoord = 'GCJ-02', startTime, endTime }) {
      if (deviceNo && startTime && endTime) {
        if (!this.isWithin31Days(startTime, endTime)) {
          this.$message.warning('暂时只支持查询31天以内的数据');
          return false;
        }
        if (this.isStartGreaterEnd(startTime, endTime)) {
          this.$message.warning('开始时间不能大于结束时间');
          return false;
        }
        globalLoading = Loading.service({
          lock: true,
          text: '加载中...',
          background: 'rgba(0, 0, 0, 0.7)'
        });

        try {
          const res = await api.getPlyLocus({ deviceNo, carNo, returnCoord, startTime, endTime });
          if (!res || res.code !== 1) {
            this.$message.error((res && (res.msg || res.statusText)) || '轨迹查询失败，请稍后重试');
            return false;
          }

          const locusData = res.data || [];
          if (locusData.length === 0) {
            this.$message.error('暂无轨迹');
            return false;
          }

          if (this.startMarker && this.endMarker) {
            window.mainMap.remove(this.startMarker);
            window.mainMap.remove(this.endMarker);
            this.startMarker = null;
            this.endMarker = null;
          }

          const result = locusData.map((subArray) => [subArray.x, subArray.y]);
          this.drawPolyline(result);
        } catch (error) {
          this.$message.error('轨迹查询异常，请稍后重试');
        } finally {
          if (globalLoading) {
            globalLoading.close();
            globalLoading = null;
          }
        }
      } else {
        await this.$msgbox('查询前请先完善查询条件', '', {
          confirmButtonText: '确定',
          showClose: false
        });
      }
    },
    handleSelect(item) {
      // console.log(item);
    },
    // draw trajectory polyline
    drawPolyline(path) {
      if (this.polyline) {
        this.map.remove(this.polyline); // remove previous trajectory
      }
      // create new trajectory polyline
      this.polyline = new AMap.Polyline({
        path: path,
        isOutline: true,
        outlineColor: '#ffeeee',
        borderWeight: 0.5,
        strokeWeight: 2,
        strokeOpacity: 0.9,
        strokeColor: '#15AD2E',
        lineJoin: 'round'
      });
      // add polyline to map
      this.map.add(this.polyline);
      // adjust viewport to fit trajectory
      this.setMapViews(path);
      // add start/end markers
      this.addStarToEndMarder(path);
    },
    // fit map view to all path points
    setMapViews(path) {
      const markers = path.map((coord) => new AMap.Marker({ position: coord }));
      this.map.setFitView(markers);
    },
    // add start and end markers
    addStarToEndMarder(path) {
      const lastIndex = path.length - 1;
      const startMarker = new AMap.Marker({
        position: path[0],
        icon: new AMap.Icon({
          size: new AMap.Size(50, 50),
          image: carStartIcon,
          imageSize: new AMap.Size(20, 28)
        }),
        offset: new AMap.Pixel(-33, -30)
      });
      const endMarker = new AMap.Marker({
        position: path[lastIndex],
        icon: new AMap.Icon({
          size: new AMap.Size(50, 50),
          image: carEndIcon,
          imageSize: new AMap.Size(20, 28)
        }),
        offset: new AMap.Pixel(-33, -30)
      });
      this.startMarker = startMarker;
      this.endMarker = endMarker;
      window.mainMap.add(startMarker);
      window.mainMap.add(endMarker);
    },
    // return to base map layout
    backBiBaseLayer() {
      if (this.polyline) {
        this.map.remove(this.polyline); // remove trajectory
      }
      if (this.startMarker && this.endMarker) {
        window.mainMap.remove(this.startMarker);
        window.mainMap.remove(this.endMarker);
        this.startMarker = null;
        this.endMarker = null;
      }
      this.$emit('showBaseLayer');
    },
    // check if range is within 31 days
    isWithin31Days(startTimestamp, endTimestamp) {
      // milliseconds in one day
      const oneDayInMilliseconds = 24 * 60 * 60 * 1000;
      // milliseconds in 31 days
      const thirtyDaysInMilliseconds = 31 * oneDayInMilliseconds;
      // calculate time difference
      const timeDifference = endTimestamp - startTimestamp;
      // check if larger than 31 days
      if (timeDifference > thirtyDaysInMilliseconds) {
        return false; // exceed 31 days
      } else {
        return true; // within 31 days
      }
    },
    isStartGreaterEnd(startTimestamp, endTimestamp) {
      if (startTimestamp > endTimestamp) {
        return true;
      } else {
        return false;
      }
    },
    destroy() {
      window.mainMap.remove(this.startMarker);
      window.mainMap.remove(this.endMarker);
      this.startMarker = null;
      this.endMarker = null;
    }
  }
};
</script>

<style lang="scss" scoped>
#TrajectoryBox {
  width: 300px;
  background-color: white;
  padding: 15px;
  border-radius: 5px;

  .trajectoryForm {
    width: 100%;

    .el-form-item {
      margin-bottom: 10px;

      .timePicker {
        width: 100%;
      }
    }

    .inline-input {
      width: 100%;
    }
  }

  .btnBlock {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    align-content: center;
    margin-top: 20px;

    .btnItem {
      width: 50%;
    }
  }
}
</style>

